import React from 'react';

import { cssMap } from '@atlaskit/css';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable } from '@atlaskit/primitives/pressable';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';

import type { Path } from '../data/types';

const iconSpacingStyles = cssMap({
	space075: {
		paddingBlock: token('space.075'),
		paddingInline: token('space.075'),
	},
});

const summaryContainerStyles = xcss({
	display: 'grid',
	padding: 'space.200',
	alignItems: 'center',
	columnGap: 'space.050',
	gridTemplateColumns: '16fr 16fr 1fr',
	backgroundColor: 'color.background.selected',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border.selected',
	borderRadius: 'radius.large',
	color: 'color.text.selected',
	marginBlockEnd: 'space.150',
});

const pendingStyles = xcss({
	marginInline: 'space.200',
});

const questionSummaryStyles = xcss({
	margin: 'space.0',
	font: 'font.body.small',
	fontWeight: 'font.weight.semibold',
	textAlign: 'left',
});

const answerSummaryStyles = xcss({
	margin: 'space.0',
	justifySelf: 'end',
	textAlign: 'end',
});
/**
 * __Summary__
 *
 * A summary button that displays the previous selections on the left-hand-side modal dialog.
 *
 */
const Summary = ({
	questionAndAnswerSummary,
	onClick,
	isPending,
}: {
	questionAndAnswerSummary: Path;
	onClick: () => void;
	isPending: boolean;
}): React.JSX.Element => {
	return (
		<Pressable
			xcss={[summaryContainerStyles, isPending && pendingStyles]}
			onClick={onClick}
			key={questionAndAnswerSummary.question}
			type="button"
		>
			<Box as="p" xcss={questionSummaryStyles}>
				{questionAndAnswerSummary.question}
			</Box>
			<Box as="p" xcss={answerSummaryStyles}>
				{questionAndAnswerSummary.answer}
			</Box>
			<Flex xcss={iconSpacingStyles.space075}>
				<ChevronRightIcon label="expand" size="small" />
			</Flex>
		</Pressable>
	);
};

export default Summary;
